var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "36.000000pt",
    height: "36.000000pt",
    viewBox: "0 0 36.000000 36.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,36.000000) scale(0.050000,-0.050000)",
    fill: "#ea6c2d",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M227 582 c-34 -22 -69 -48 -76 -60 -20 -32 52 -26 98 9 121 91 311 -13 311 -171 0 -158 -190 -262 -311 -171 -56 43 -123 42 -88 0 108 -130 330 -111 420 37 139 228 -126 494 -354 356z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 410 l-47 -50 47 -50 c45 -48 100 -67 100 -34 0 9 -11 28 -25 42 -20 20 -8 24 63 19 57 -5 91 2 97 18 6 18 -19 25 -87 25 -75 0 -91 5 -72 24 13 13 24 31 24 40 0 33 -55 14 -100 -34z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.913bb003c361330f12552e2a79713e56.svg";
export { ForwardRef as ReactComponent };